export const ENUM_SIZE = 64;
export const CLIMB_THRESHOLD_METERS = 5.0;
export const ELEVATION_MAX_ZOOM = 14;

export function aDescendsB(a: number, b: number): boolean {
  let cursor = a;
  while (b < cursor) {
    cursor = Math.floor((cursor - 1) / ENUM_SIZE);
  }
  return b === cursor;
}


export function getPointSource(id: bigint): {type: 'node'|'relation'|'way'; id: bigint} {
  if (id >= 1099511627776n) {
    return {type: 'relation', id: id - 1099511627776n};
  }
  return {type: (id & 1n) === 0n ? 'node' : 'way', id: id >> 1n};
}

export function getPathSourceWay(pathId: bigint): bigint {
  return pathId >> 1n;
}

export function getBoundarySource(id: bigint): {type: 'node'|'relation'|'way'; id: bigint} {
  if (id >= 2199023255552n) {
    return {type: 'node', id: id - 2199023255552n};
  } else if (id >= 1099511627776n) {
    return {type: 'way', id: id - 1099511627776n};
  } else {
    return {type: 'relation', id};
  }
}

export enum PointCategory {
  ANY = 0,
  RESUPPLY = 1,
  RESUPPLY_CONVENIENCE = 65,
  RESUPPLY_FUEL = 66,
  RESUPPLY_OUTDOOR = 67,
  RESUPPLY_POST_OFFICE = 68,
  RESUPPLY_SUPERMARKET = 69,
  SAFETY = 2,
  SAFETY_CLINIC = 129,
  SAFETY_DEFIBRILLATOR = 130,
  SAFETY_EMERGENCY_PHONE = 131,
  SAFETY_MOUNTAIN_RESCUE = 132,
  SAFETY_PHARMACY = 133,
  LODGING = 3,
  LODGING_CAMP = 193,
  LODGING_CAMP_PITCH = 12353,
  LODGING_CAMP_SITE = 12354,
  LODGING_CAMP_CARAVAN_SITE = 12355,
  LODGING_HUT = 194,
  LODGING_HUT_ALPINE = 12417,
  LODGING_HUT_WILDERNESS = 12418,
  LODGING_HOSTEL = 195,
  LODGING_ROOM = 196,
  LODGING_ROOM_CHALET = 12545,
  LODGING_ROOM_GUEST_HOUSE = 12546,
  LODGING_ROOM_HOTEL = 12547,
  LODGING_ROOM_MOTEL = 12548,
  FACILITY = 4,
  FACILITY_FIRE = 257,
  FACILITY_FIRE_BARBECUE = 16449,
  FACILITY_FIRE_PIT = 16450,
  FACILITY_PICNIC = 258,
  FACILITY_PICNIC_SITE = 16513,
  FACILITY_PICNIC_TABLE = 16514,
  FACILITY_BICYCLE_REPAIR = 259,
  FACILITY_LAUNDRY = 260,
  FACILITY_SHELTER = 261,
  FACILITY_SHOWER = 262,
  FACILITY_TOILETS = 263,
  WATER = 5,
  WATER_DRINKING = 321,
  WATER_POINT = 322,
  WATER_SPRING = 323,
  WATER_TAP = 324,
  INFORMATION = 6,
  INFORMATION_GUIDE_POST = 385,
  INFORMATION_RANGER_STATION = 386,
  INFORMATION_VISITOR_CENTER = 387,
  SIGHT = 7,
  SIGHT_OBSERVATION_TOWER = 449,
  SIGHT_RUINS = 450,
  SIGHT_VIEWPOINT = 451,
  NATURAL = 8,
  NATURAL_CAVE_ENTRANCE = 513,
  NATURAL_HOT_SPRING = 514,
  NATURAL_PEAK = 515,
  NATURAL_SADDLE = 516,
  NATURAL_MOUNTAIN_PASS = 517,
  NATURAL_VOLCANO = 518,
  NATURAL_WATERFALL = 519,
  NATURAL_GLACIER = 520,
  NATURAL_LAKE = 521,
  NATURAL_BAY = 522,
  NATURAL_STRAIT = 523,
  ACCESS = 9,
  ACCESS_PARKING = 577,
  ACCESS_TRAILHEAD = 578,
  ACCESS_TRANSIT = 579,
  ACCESS_TRANSIT_BUS_STOP = 37057,
  ACCESS_TRANSIT_FERRY_TERMINAL = 37058,
  ACCESS_TRANSIT_STATION = 37059,
  ACCESS_TRANSIT_AIRPORT = 37060,
  CLIMBING = 10,
  CLIMBING_ROUTE = 641,
  PARK = 11,
  PARK_NATIONAL_PARK = 705,
  PARK_NATURE_RESERVE = 706,
  PARK_PROTECTED_AREA = 707,
  PLACE = 12,
  PLACE_COUNTRY = 769,
  PLACE_STATE = 770,
  PLACE_CITY = 771,
  PLACE_TOWN = 772,
  PLACE_VILLAGE = 773,
  PLACE_SUBURB = 774,
  PLACE_NEIGHBOURHOOD = 775,
}
export enum RelationCategory {
  ANY = 0,
  BOUNDARY = 1,
  BOUNDARY_ABORIGINAL_LANDS = 65,
  BOUNDARY_ADMINISTRATIVE = 66,
  BOUNDARY_ADMINISTRATIVE_1 = 4225,
  BOUNDARY_ADMINISTRATIVE_2 = 4226,
  BOUNDARY_ADMINISTRATIVE_3 = 4227,
  BOUNDARY_ADMINISTRATIVE_4 = 4228,
  BOUNDARY_ADMINISTRATIVE_5 = 4229,
  BOUNDARY_ADMINISTRATIVE_6 = 4230,
  BOUNDARY_ADMINISTRATIVE_7 = 4231,
  BOUNDARY_ADMINISTRATIVE_8 = 4232,
  BOUNDARY_ADMINISTRATIVE_9 = 4233,
  BOUNDARY_ADMINISTRATIVE_10 = 4234,
  BOUNDARY_ADMINISTRATIVE_11 = 4235,
  BOUNDARY_FOREST = 67,
  BOUNDARY_NATIONAL_PARK = 68,
  BOUNDARY_PROTECTED_AREA = 69,
  BOUNDARY_PROTECTED_AREA_1A = 4417,
  BOUNDARY_PROTECTED_AREA_1B = 4418,
  BOUNDARY_PROTECTED_AREA_2 = 4419,
  BOUNDARY_PROTECTED_AREA_3 = 4420,
  BOUNDARY_PROTECTED_AREA_4 = 4421,
  BOUNDARY_PROTECTED_AREA_5 = 4422,
  BOUNDARY_PROTECTED_AREA_6 = 4423,
  BOUNDARY_CLIMBING = 70,
  BOUNDARY_CLIMBING_AREA = 4481,
  BOUNDARY_CLIMBING_BOULDER = 4482,
  BOUNDARY_CLIMBING_CRAG = 4483,
  BOUNDARY_NATURE_RESERVE = 71,
  ROUTE = 2,
  TRANSPORT = 129,
  TRANSPORT_BUS = 8257,
  TRANSPORT_DETOUR = 8258,
  TRANSPORT_FERRY = 8259,
  TRANSPORT_LIGHT_RAIL = 8260,
  TRANSPORT_RAILWAY = 8261,
  TRANSPORT_ROAD = 8262,
  TRANSPORT_SUBWAY = 8263,
  TRANSPORT_TRAIN = 8264,
  TRANSPORT_TRACKS = 8265,
  TRANSPORT_TRAM = 8266,
  TRANSPORT_TROLLEYBUS = 8267,
  TRAIL = 130,
  TRAIL_BICYCLE = 8321,
  TRAIL_CANOE = 8322,
  TRAIL_FOOT = 8323,
  TRAIL_HIKING = 8324,
  TRAIL_HORSE = 8325,
  TRAIL_INLINE_SKATES = 8326,
  TRAIL_MTB = 8327,
  TRAIL_PISTE = 8328,
  TRAIL_RUNNING = 8329,
  TRAIL_SKIING = 8330,
  NATURAL = 3,
  NATURAL_GLACIER = 193,
  NATURAL_LAKE = 194,
  NATURAL_BAY = 195,
  NATURAL_STRAIT = 196,
}
export const SEARCHABLE_POINT_LABELS = new Map<number, string>([
  [PointCategory.ACCESS_TRAILHEAD, 'Trailhead'],
  [PointCategory.ACCESS_TRANSIT_AIRPORT, 'Airport'],
  [PointCategory.ACCESS_TRANSIT_FERRY_TERMINAL, 'Ferry terminal'],
  [PointCategory.ACCESS_TRANSIT_STATION, 'Station'],
  [PointCategory.CLIMBING_ROUTE, 'Climbing route'],
  [PointCategory.INFORMATION_RANGER_STATION, 'Ranger station'],
  [PointCategory.INFORMATION_VISITOR_CENTER, 'Visitor center'],
  [PointCategory.LODGING_CAMP_CARAVAN_SITE, 'Caravan site'],
  [PointCategory.LODGING_CAMP_SITE, 'Campground'],
  [PointCategory.LODGING_HOSTEL, 'Hostel'],
  [PointCategory.LODGING_HUT_ALPINE, 'Alpine hut'],
  [PointCategory.LODGING_HUT_WILDERNESS, 'Wilderness hut'],
  [PointCategory.LODGING_ROOM_CHALET, 'Chalet'],
  [PointCategory.LODGING_ROOM_GUEST_HOUSE, 'Guest house'],
  [PointCategory.LODGING_ROOM_HOTEL, 'Hotel'],
  [PointCategory.LODGING_ROOM_MOTEL, 'Motel'],
  [PointCategory.NATURAL_BAY, 'Bay'],
  [PointCategory.NATURAL_CAVE_ENTRANCE, 'Cave'],
  [PointCategory.NATURAL_GLACIER, 'Glacier'],
  [PointCategory.NATURAL_HOT_SPRING, 'Hot spring'],
  [PointCategory.NATURAL_LAKE, 'Lake'],
  [PointCategory.NATURAL_MOUNTAIN_PASS, 'Pass'],
  [PointCategory.NATURAL_PEAK, 'Peak'],
  [PointCategory.NATURAL_SADDLE, 'Saddle'],
  [PointCategory.NATURAL_STRAIT, 'Strait'],
  [PointCategory.NATURAL_VOLCANO, 'Volcano'],
  [PointCategory.NATURAL_WATERFALL, 'Waterfall'],
  [PointCategory.SAFETY_CLINIC, 'Clinic'],
  [PointCategory.SAFETY_MOUNTAIN_RESCUE, 'Mountain rescue'],
  [PointCategory.SIGHT_OBSERVATION_TOWER, 'Observation tower'],
  [PointCategory.SIGHT_VIEWPOINT, 'Viewpoint'],
  [PointCategory.WATER_SPRING, 'Spring'],
  [PointCategory.WATER_TAP, 'Water tap'],
]);
export const NATIONAL_PARK_CATEGORIES = new Set<number>([
  RelationCategory.BOUNDARY_NATIONAL_PARK,
  RelationCategory.BOUNDARY_PROTECTED_AREA_2,
]);
export enum WayCategory {
  ANY = 0,
  HIGHWAY = 1,
  RAIL = 65,
  RAIL_NARROW_GAUGE = 4161,
  RAIL_PRESERVED = 4162,
  RAIL_FUNICULAR = 4163,
  RAIL_SUBWAY = 4164,
  RAIL_LIGHT_RAIL = 4165,
  RAIL_TRAM = 4166,
  RAIL_MONORAIL = 4167,
  RAIL_YARD = 4168,
  RAIL_SIDING = 4169,
  RAIL_SPUR = 4170,
  ROAD = 66,
  ROAD_MOTORWAY = 4225,
  ROAD_TRUNK = 4226,
  ROAD_PRIMARY = 4227,
  ROAD_SECONDARY = 4228,
  ROAD_TERTIARY = 4229,
  ROAD_UNCLASSIFIED = 4230,
  ROAD_RESIDENTIAL = 4231,
  ROAD_MOTORWAY_LINK = 4232,
  ROAD_TRUNK_LINK = 4233,
  ROAD_PRIMARY_LINK = 4234,
  ROAD_SECONDARY_LINK = 4235,
  ROAD_TERTIARY_LINK = 4236,
  ROAD_LIVING_STREET = 4237,
  ROAD_SERVICE = 4238,
  ROAD_PEDESTRIAN = 4239,
  ROAD_TRACK = 4240,
  ROAD_BUS_GUIDEWAY = 4241,
  ROAD_ESCAPE = 4242,
  ROAD_RACEWAY = 4243,
  ROAD_BUSWAY = 4244,
  ROAD_CONSTRUCTION = 4245,
  ROAD_CONSTRUCTION_MOTORWAY = 271681,
  ROAD_CONSTRUCTION_TRUNK = 271682,
  ROAD_CONSTRUCTION_PRIMARY = 271683,
  ROAD_CONSTRUCTION_SECONDARY = 271684,
  ROAD_CONSTRUCTION_TERTIARY = 271685,
  ROAD_CONSTRUCTION_MINOR = 271686,
  PATH = 67,
  PATH_FOOTWAY = 4289,
  PATH_FOOTWAY_SIDEWALK = 274497,
  PATH_FOOTWAY_CROSSING = 274498,
  PATH_BRIDLEWAY = 4290,
  PATH_STEPS = 4291,
  PATH_CORRIDOR = 4292,
  PATH_CYCLEWAY = 4293,
  PATH_VIA_FERRATA = 4294,
  PISTE = 2,
  PISTE_DOWNHILL = 129,
  PISTE_NORDIC = 130,
  PISTE_SKITOUR = 131,
  PISTE_SLED = 132,
  PISTE_HIKE = 133,
  PISTE_SLEIGH = 134,
  PISTE_ICE_SKATE = 135,
  PISTE_SKI_JUMP = 136,
  PISTE_CONNECTION = 137,
  AERIALWAY = 3,
  AERIALWAY_CABLE_CAR = 193,
  AERIALWAY_GONDOLA = 194,
  AERIALWAY_MIXED_LIFT = 195,
  AERIALWAY_CHAIR_LIFT = 196,
  AERIALWAY_DRAG_LIFT = 197,
  AERIALWAY_T_BAR = 198,
  AERIALWAY_J_BAR = 199,
  AERIALWAY_PLATTER = 200,
  AERIALWAY_ROPE_TOW = 201,
  AERIALWAY_MAGIC_CARPET = 202,
  AERIALWAY_ZIP_LINE = 203,
  AERIALWAY_GOODS = 204,
  WATERWAY = 4,
  WATERWAY_FERRY = 257,
  WATERWAY_RIVER = 258,
  WATERWAY_STREAM = 259,
  WATERWAY_CANAL = 260,
  WATERWAY_DITCH = 261,
  WATERWAY_DRAIN = 262,
  AEROWAY = 5,
  AEROWAY_RUNWAY = 321,
  AEROWAY_TAXIWAY = 322,
  AEROWAY_TAXILANE = 323,
  AEROWAY_HELIPAD = 324,
  AEROWAY_APRON = 325,
  AEROWAY_AERODROME = 326,
  NATURAL = 6,
  NATURAL_COASTLINE = 385,
  NATURAL_TREE_ROW = 386,
  NATURAL_CLIFF = 387,
  NATURAL_RIDGE = 388,
  NATURAL_ARETE = 389,
  NATURAL_VALLEY = 390,
  MAN_MADE = 7,
  MAN_MADE_PIER = 449,
  MAN_MADE_BREAKWATER = 450,
  MAN_MADE_GROYNE = 451,
}
export const PATH_TRAITS = [
  {key: 'tracktype', shift: 0, mask: 7},
  {key: 'bicycle', shift: 3, mask: 3},
  {key: 'foot', shift: 5, mask: 3},
  {key: 'horse', shift: 7, mask: 3},
  {key: 'direction', shift: 9, mask: 3},
  {key: 'mtb_scale', shift: 11, mask: 7},
  {key: 'trail_visibility', shift: 14, mask: 7},
  {key: 'sac_scale', shift: 17, mask: 7},
  {key: 'informal', shift: 20, mask: 1},
  {key: 'dog', shift: 21, mask: 3},
  {key: 'piste_grooming', shift: 23, mask: 3},
  {key: 'piste_difficulty', shift: 25, mask: 7},
  {key: 'via_ferrata_scale', shift: 28, mask: 7},
];

export function unpackPathTraits(traits: number, data: {[key: string]: unknown}): void {
  for (const {key, shift, mask} of PATH_TRAITS) {
    data[key] = (traits >> shift) & mask;
  }
}

